import { formatAddressBlock } from "./contactDraft";
import type { ContactDraft } from "./types";

export function ContactAddressForm({
  draft,
  editing,
  onChange,
}: {
  draft: ContactDraft;
  editing: boolean;
  onChange: (patch: Partial<ContactDraft>) => void;
}) {
  const formatted = formatAddressBlock(draft);
  if (!editing) {
    return formatted ? <p className="contact-address-view">{formatted}</p> : <p className="muted">No address on file.</p>;
  }

  return (
    <div className="contact-form-grid">
      <label className="field">
        Address line 1
        <input value={draft.address_line1} onChange={(e) => onChange({ address_line1: e.target.value })} />
      </label>
      <label className="field">
        Address line 2
        <input value={draft.address_line2} onChange={(e) => onChange({ address_line2: e.target.value })} />
      </label>
      <label className="field">
        Address line 3
        <input value={draft.address_line3} onChange={(e) => onChange({ address_line3: e.target.value })} />
      </label>
      <label className="field">
        City
        <input value={draft.city} onChange={(e) => onChange({ city: e.target.value })} />
      </label>
      <label className="field">
        State / region
        <input value={draft.state_region} onChange={(e) => onChange({ state_region: e.target.value })} />
      </label>
      <label className="field">
        Postal code
        <input value={draft.postal_code} onChange={(e) => onChange({ postal_code: e.target.value })} />
      </label>
      <label className="field">
        Country code
        <input
          value={draft.country_code}
          onChange={(e) => onChange({ country_code: e.target.value })}
          placeholder="US"
          maxLength={2}
        />
      </label>
      <label className="field">
        Country (as received)
        <input value={draft.country_raw} onChange={(e) => onChange({ country_raw: e.target.value })} />
      </label>
    </div>
  );
}
